// src/components/Header.js
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from '../images/1122.png';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    navigate("/login");
  };

  const getTitle = () => {
    switch (location.pathname) {
      case "/shipment":
        return "Shipment";
      case "/china":
        return "CN";
      case "/customerService":
        return "Customer Service";
      case "/CSAttendance":
        return "Attendance";
      case "/admin":
        return "Admin";
      case "/finance":
        return "Finance";
      case "/financeAdmin":
        return "Finance";
      case "/delivery":
        return "Delivery";
      case "/scanner":
        return "Scanner";
      case "/banking":
        return "Banking";
      default:
        return "";
    }
  };

  const getBackground = () => {
    switch (location.pathname) {
      case "/shipment":
        return "bg-red-900";
      case "/china":
        return "bg-slate-600";
      case "/ShippedTo":
        return "bg-slate-600";
      case "/customerService":
        return "bg-slate-800";
      case "/CSAttendance":
        return "bg-slate-800";
      case "/admin":
        return "bg-black";
      case "/finance":
        return "bg-green-800";
      case "/financeAdmin":
        return "bg-green-800";
      case "/delivery":
        return "bg-blue-300";
      case "/banking":
        return "bg-indigo-900";
      default:
        return "bg-black";
    }
  };

  const getColor = () => {
    switch (location.pathname) {
      case "/shipment":
        return "text-red-900";
      case "/china":
        return "text-slate-600";
      case "/customerService":
        return "text-slate-800";
      case "/CSAttendance":
        return "text-slate-800";
      case "/admin":
        return "text-black";
      case "/finance":
        return "text-green-800";
      case "/financeAdmin":
        return "text-green-800";
      case "/delivery":
        return "text-blue-500";
      default:
        return "";
    }
  };

  const getUserName = () => {
    const stored = localStorage.getItem("user");
    if (!stored) return "USER";
    try {
      const parsed = JSON.parse(stored);
      return (parsed.NAME || parsed.UserName || parsed.EMAIL || "USER").toUpperCase();
    } catch (e) {
      return stored.toUpperCase();
    }
  };

  const user = getUserName();

  return (
    <header className={`fixed top-0 left-0 w-full px-3 md:px-5 py-2 md:py-4 flex items-center justify-between z-10 text-white ${getBackground()}`}>
      {/* Logo + Title */}
      <Link to="/" className="flex items-center gap-2 min-w-0 flex-shrink">
        <img src={logo} alt="logo" className="h-8 w-8 md:h-10 md:w-10 flex-shrink-0" />
        <span className="text-base md:text-xl font-semibold hidden sm:inline">HuluOrder</span>
        <span className="text-[10px] bg-white/20 px-1.5 py-0.5 rounded-full ml-1 opacity-70 font-mono">v2.8.1</span>
        {getTitle() && (
          <span className={`text-xs md:text-base px-2 py-0.5 md:px-3 md:py-1 rounded-md bg-white font-semibold ${getColor()} whitespace-nowrap ml-2`}>
            {getTitle()}
          </span>
        )}
      </Link>

      {/* User + Logout */}
      <div className="flex items-center gap-2 md:gap-4 flex-shrink-0">
        <span className="text-sm md:text-2xl font-bold truncate max-w-[80px] md:max-w-[200px]">{user}</span>
        <button className="text-xs md:text-lg hover:opacity-80 transition-opacity" onClick={handleLogout}>Logout</button>
      </div>
    </header>
  );
};

export default Header;
